import React, { useEffect, useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SparklesIcon, VideoIcon, TrendingUpIcon, FilmIcon, CameraIcon, ApertureIcon, ZapIcon, RocketIcon, BrainIcon, StarIcon, HeartIcon, HomeIcon, PresentationIcon } from 'lucide-react';
const Slideshow = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
  // Marketing History Slides
  {
    type: 'marketing',
    title: 'La Era de la Publicidad Impresa',
    subtitle: '1450 - 1920',
    description: 'La invención de la imprenta revolucionó la comunicación. Los primeros anuncios impresos transformaron el comercio y establecieron las bases del marketing moderno.',
    image: 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    icon: <SparklesIcon className="h-16 w-16" data-id="element-601" />,
    gradient: 'from-purple-600 to-pink-600'
  }, {
    type: 'filmmaker',
    title: 'El Arte de Contar Historias Visuales',
    subtitle: 'Filmmaking',
    description: 'Un filmmaker no solo captura imágenes, crea mundos. Cada frame es una decisión artística que comunica emoción, mensaje y propósito.',
    image: 'https://images.unsplash.com/photo-1579566346927-c68383817a25?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    icon: <VideoIcon className="h-16 w-16" data-id="element-602" />,
    gradient: 'from-blue-600 to-purple-600'
  }, {
    type: 'marketing',
    title: 'La Revolución de la Radio y TV',
    subtitle: '1920 - 1980',
    description: 'Los medios audiovisuales llevaron el marketing a los hogares. Las marcas comenzaron a construir identidades emocionales a través de jingles y comerciales memorables.',
    image: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    icon: <TrendingUpIcon className="h-16 w-16" data-id="element-603" />,
    gradient: 'from-pink-600 to-red-600'
  }, {
    type: 'filmmaker',
    title: 'La Cinematografía como Lenguaje',
    subtitle: 'Técnica y Visión',
    description: 'La iluminación, composición y movimiento de cámara son el vocabulario del filmmaker. Cada elección técnica sirve a la narrativa y amplifica el mensaje.',
    image: 'https://images.unsplash.com/photo-1585647347483-22b66260dfff?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    icon: <CameraIcon className="h-16 w-16" data-id="element-604" />,
    gradient: 'from-green-600 to-teal-600'
  }, {
    type: 'marketing',
    title: 'La Era Digital',
    subtitle: '1990 - 2010',
    description: 'Internet transformó el marketing para siempre. Las marcas descubrieron nuevas formas de conectar, medir y optimizar su comunicación en tiempo real.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    icon: <SparklesIcon className="h-16 w-16" data-id="element-605" />,
    gradient: 'from-cyan-600 to-blue-600'
  }, {
    type: 'filmmaker',
    title: 'Post-Producción: Donde la Magia Cobra Vida',
    subtitle: 'Edición y Color',
    description: 'La post-producción es donde la visión se materializa. Color grading, efectos visuales y edición rítmica transforman footage en experiencias cinematográficas.',
    image: 'https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    icon: <FilmIcon className="h-16 w-16" data-id="element-606" />,
    gradient: 'from-purple-600 to-pink-600'
  }, {
    type: 'marketing',
    title: 'Marketing de Contenidos y Social Media',
    subtitle: '2010 - Presente',
    description: 'Las redes sociales democratizaron la comunicación. El contenido de valor se convirtió en la nueva publicidad, construyendo comunidades y conversaciones auténticas.',
    image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    icon: <TrendingUpIcon className="h-16 w-16" data-id="element-607" />,
    gradient: 'from-pink-600 to-purple-600'
  }, {
    type: 'filmmaker',
    title: 'Dirección: Orquestando la Visión',
    subtitle: 'El Director como Visionario',
    description: 'Un director une todos los elementos: actuación, cámara, sonido y diseño. Su visión cohesiva transforma ideas en narrativas poderosas que resuenan con audiencias.',
    image: 'https://images.unsplash.com/photo-1576633587382-13ddf37b1fc1?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    icon: <ApertureIcon className="h-16 w-16" data-id="element-608" />,
    gradient: 'from-orange-600 to-red-600'
  }, {
    type: 'marketing',
    title: 'Inteligencia Artificial y Personalización',
    subtitle: 'El Futuro del Marketing',
    description: 'La IA está redefiniendo el marketing. Personalización a escala, predicción de comportamiento y optimización automática crean experiencias únicas para cada usuario.',
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    icon: <SparklesIcon className="h-16 w-16" data-id="element-609" />,
    gradient: 'from-purple-600 to-blue-600'
  }, {
    type: 'filmmaker',
    title: 'Sonido: La Dimensión Invisible',
    subtitle: 'Audio y Música',
    description: 'El diseño de sonido y la música son el alma emocional del film. Un buen soundtrack eleva la narrativa y crea momentos que permanecen en la memoria.',
    image: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    icon: <VideoIcon className="h-16 w-16" data-id="element-610" />,
    gradient: 'from-indigo-600 to-purple-600'
  },
  // NEW SLIDES - Nuestros Proyectos
  {
    type: 'marketing',
    title: 'Momentos que Permanecen',
    subtitle: 'Producción de Eventos',
    description: 'Capturamos los momentos más importantes de tu vida o marca. Cada evento es una historia única que merece ser contada con elegancia y emoción.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/txgJWFBPGiVzGAMZKLspaJ/_DSC0542.jpg',
    icon: <CameraIcon className="h-16 w-16" data-id="element-611" />,
    gradient: 'from-rose-600 to-pink-600'
  }, {
    type: 'filmmaker',
    title: 'Turismo que Inspira',
    subtitle: 'Contenido de Destinos',
    description: 'Transformamos destinos en experiencias visuales. Cada locación cuenta su propia historia, invitando a audiencias a descubrir y explorar.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ikr8fTVep3PE4BhWR4MVWN/IMG_0855.jpg',
    icon: <VideoIcon className="h-16 w-16" data-id="element-612" />,
    gradient: 'from-amber-600 to-orange-600'
  }, {
    type: 'marketing',
    title: 'Campañas Automotrices',
    subtitle: 'Performance y Estilo',
    description: 'Desde construcción hasta aventura, capturamos la esencia de cada vehículo. Producción audiovisual que destaca potencia, diseño y versatilidad.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qCbtV4tfuF1rffu8vPCxGR/IMG_1468.jpg',
    icon: <RocketIcon className="h-16 w-16" data-id="element-613" />,
    gradient: 'from-blue-600 to-cyan-600'
  }, {
    type: 'filmmaker',
    title: 'Conexión Humana',
    subtitle: 'Storytelling Auténtico',
    description: 'Las mejores campañas conectan con personas reales. Creamos contenido que celebra momentos genuinos y construye comunidades leales.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mVaq8d17WpbJ5Ax2k1wyWy/IMG_1881.jpg',
    icon: <HeartIcon className="h-16 w-16" data-id="element-614" />,
    gradient: 'from-teal-600 to-green-600'
  }, {
    type: 'marketing',
    title: 'Acción y Movimiento',
    subtitle: 'Producción Dinámica',
    description: 'Capturamos la adrenalina y la emoción. Desde off-road hasta alta velocidad, producimos contenido que transmite energía y performance.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/r5tYdm8FEmADL3Jyfs3PY1/IMG_3368.jpg',
    icon: <ZapIcon className="h-16 w-16" data-id="element-615" />,
    gradient: 'from-violet-600 to-purple-600'
  },
  // GRAN FINALE - Transición
  {
    type: 'finale',
    title: 'El Pasado nos Enseñó',
    subtitle: 'El Presente nos Inspira',
    description: 'Cada era del marketing y cada técnica de filmmaking nos ha traído hasta aquí. Ahora, la convergencia de arte, tecnología y estrategia abre un nuevo capítulo.',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=2072&q=80',
    icon: <ZapIcon className="h-16 w-16" data-id="element-616" />,
    gradient: 'from-yellow-600 to-orange-600'
  },
  // GRAN FINALE - Revelación
  {
    type: 'finale',
    title: 'Donde Todo Converge',
    subtitle: 'Marketing + Filmmaking + IA',
    description: 'Grupo Reflex fusiona décadas de sabiduría creativa con la potencia de la inteligencia artificial. No solo contamos historias, las proyectamos con precisión y propósito.',
    image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    icon: <BrainIcon className="h-16 w-16" data-id="element-617" />,
    gradient: 'from-purple-600 to-pink-600'
  },
  // GRAN FINALE - Powerhouse
  {
    type: 'finale',
    title: '¡Has Llegado al Lugar Indicado!',
    subtitle: 'La Powerhouse de la IA',
    description: 'Somos Grupo Reflex: donde la creatividad humana se encuentra con la inteligencia artificial. Transformamos ideas en proyectos funcionales que conectan, emocionan y convierten.',
    image: 'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    icon: <RocketIcon className="h-16 w-16" data-id="element-618" />,
    gradient: 'from-cyan-600 to-purple-600',
    isMainFinale: true
  },
  // GRAN FINALE - CTA Final
  {
    type: 'finale',
    title: 'Tu Siguiente Proyecto Comienza Aquí',
    subtitle: 'Grupo Reflex',
    description: 'Estamos listos para proyectar la grandeza de tu marca. Contáctanos y descubre cómo la IA puede transformar tu visión en realidad.',
    image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    icon: <StarIcon className="h-16 w-16" data-id="element-619" />,
    gradient: 'from-pink-600 to-purple-600',
    showLogo: true
  }];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 8000);
    return () => clearInterval(interval);
  }, [slides.length]);
  const currentSlideData = slides[currentSlide];
  return <div className="fixed inset-0 w-full h-screen bg-gray-900 overflow-hidden" data-id="element-620">
      {/* Navigation Bar */}
      <div className="absolute top-6 left-6 z-50 flex gap-4" data-id="element-621">
        <Link to="/" className="flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 backdrop-blur-md rounded-full transition-all text-sm font-medium border border-white/10 text-white" data-id="element-622">
          <HomeIcon className="w-4 h-4" data-id="element-623" />
          <span data-id="element-624">Home</span>
        </Link>
        <Link to="/strategy" className="flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 backdrop-blur-md rounded-full transition-all text-sm font-medium border border-white/10 text-white" data-id="element-625">
          <PresentationIcon className="w-4 h-4" data-id="element-626" />
          <span data-id="element-627">Estrategia</span>
        </Link>
      </div>

      {/* Animated Background Particles */}
      <div className="absolute inset-0" data-id="element-628">
        {[...Array(30)].map((_, i) => <motion.div key={i} className="absolute w-1 h-1 bg-purple-400 rounded-full" initial={{
        x: Math.random() * window.innerWidth,
        y: Math.random() * window.innerHeight,
        opacity: 0
      }} animate={{
        y: [null, Math.random() * window.innerHeight],
        opacity: [0, 1, 0]
      }} transition={{
        duration: Math.random() * 5 + 3,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-629" />)}
      </div>
      {/* Glowing Orbs */}
      <motion.div className="absolute top-0 left-0 w-96 h-96 bg-purple-500 rounded-full opacity-20 blur-3xl" animate={{
      x: [0, 100, 0],
      y: [0, 50, 0],
      scale: [1, 1.2, 1]
    }} transition={{
      duration: 10,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-630" />
      <motion.div className="absolute bottom-0 right-0 w-96 h-96 bg-pink-500 rounded-full opacity-20 blur-3xl" animate={{
      x: [0, -100, 0],
      y: [0, -50, 0],
      scale: [1, 1.3, 1]
    }} transition={{
      duration: 12,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-631" />
      {/* Main Slide Content */}
      <AnimatePresence mode="wait" data-id="element-632">
        <motion.div key={currentSlide} initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 1.05
      }} transition={{
        duration: 1.5,
        ease: 'easeInOut'
      }} className="relative w-full h-full flex items-center justify-center" data-id="element-633">
          {/* Background Image with Ken Burns Effect */}
          <div className="absolute inset-0 overflow-hidden" data-id="element-634">
            <motion.div className="w-full h-full" initial={{
            scale: 1
          }} animate={{
            scale: 1.15
          }} transition={{
            duration: 8,
            ease: 'linear'
          }} data-id="element-635">
              <img src={currentSlideData.image} alt={currentSlideData.title} className="w-full h-full object-cover" data-id="element-636" />
            </motion.div>
            <div className={`absolute inset-0 bg-gradient-to-br ${currentSlideData.gradient} ${currentSlideData.isMainFinale ? 'opacity-80' : 'opacity-60'}`} data-id="element-637" />
            <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/50 to-transparent" data-id="element-638" />
          </div>
          {/* Content */}
          <div className="relative z-10 container mx-auto px-8 md:px-16" data-id="element-639">
            <div className="max-w-5xl mx-auto text-center" data-id="element-640">
              {/* Logo para el slide final */}
              {currentSlideData.showLogo && <motion.div initial={{
              scale: 0,
              rotate: -180
            }} animate={{
              scale: 1,
              rotate: 0
            }} transition={{
              duration: 1,
              delay: 0.3
            }} className="mb-8" data-id="element-641">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/weJPa2B6KxMjVxBcMFKGGT/LOGO_GRUPO_REFLEX.png" alt="Grupo Reflex" className="h-24 md:h-32 mx-auto brightness-0 invert" data-id="element-642" />
                </motion.div>}
              {/* Icon with glow effect */}
              {!currentSlideData.showLogo && <motion.div initial={{
              scale: 0,
              rotate: -180
            }} animate={{
              scale: 1,
              rotate: 0
            }} transition={{
              duration: 1,
              delay: 0.3
            }} className="inline-flex items-center justify-center mb-8" data-id="element-643">
                  <div className={`p-6 rounded-full bg-gradient-to-br ${currentSlideData.gradient} text-white shadow-2xl ${currentSlideData.isMainFinale ? 'animate-pulse' : ''}`} data-id="element-644">
                    {currentSlideData.icon}
                  </div>
                </motion.div>}
              {/* Subtitle */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 1,
              delay: 0.5
            }} className="mb-4" data-id="element-645">
                <span className={`inline-block px-6 py-2 rounded-full bg-gradient-to-r ${currentSlideData.gradient} text-white text-sm md:text-base font-semibold uppercase tracking-wider`} data-id="element-646">
                  {currentSlideData.subtitle}
                </span>
              </motion.div>
              {/* Title */}
              <motion.h1 initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 1,
              delay: 0.7
            }} className={`${currentSlideData.isMainFinale ? 'text-6xl md:text-8xl lg:text-9xl' : 'text-5xl md:text-7xl lg:text-8xl'} font-bold text-white mb-8 leading-tight`} data-id="element-647">
                {currentSlideData.title}
              </motion.h1>
              {/* Description */}
              <motion.p initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 1,
              delay: 0.9
            }} className={`${currentSlideData.isMainFinale ? 'text-2xl md:text-4xl' : 'text-xl md:text-3xl'} text-gray-200 max-w-4xl mx-auto leading-relaxed`} data-id="element-648">
                {currentSlideData.description}
              </motion.p>
              {/* Extra sparkles for main finale */}
              {currentSlideData.isMainFinale && <motion.div initial={{
              opacity: 0,
              scale: 0
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 1,
              delay: 1.2
            }} className="mt-12 flex justify-center gap-8" data-id="element-649">
                  {[...Array(5)].map((_, i) => <motion.div key={i} animate={{
                y: [0, -20, 0],
                opacity: [0.5, 1, 0.5]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                delay: i * 0.2
              }} data-id="element-650">
                      <StarIcon className="h-8 w-8 text-yellow-400 fill-yellow-400" data-id="element-651" />
                    </motion.div>)}
                </motion.div>}
              {/* Contact info for final slide */}
              {currentSlideData.showLogo && <motion.div initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 1,
              delay: 1.1
            }} className="mt-12 text-white text-xl md:text-2xl space-y-2" data-id="element-652">
                  <p data-id="element-653">📞 +502 4693-3600</p>
                  <p data-id="element-654">📧 reflexmediagt@gmail.com</p>
                </motion.div>}
              {/* Decorative Line */}
              <motion.div initial={{
              scaleX: 0
            }} animate={{
              scaleX: 1
            }} transition={{
              duration: 1,
              delay: 1.1
            }} className="mt-12 mx-auto w-32 h-1 bg-gradient-to-r from-transparent via-white to-transparent" data-id="element-655" />
            </div>
          </div>
          {/* Progress Indicators */}
          <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex gap-3 z-20" data-id="element-656">
            {slides.map((_, index) => <motion.div key={index} initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            delay: index * 0.1
          }} className="relative" data-id="element-657">
                <div className={`w-3 h-3 rounded-full ${index === currentSlide ? 'bg-white' : 'bg-white/30'} transition-all duration-500`} data-id="element-658" />
                {index === currentSlide && <motion.div className="absolute inset-0 rounded-full bg-white" initial={{
              scale: 1
            }} animate={{
              scale: [1, 1.5, 1]
            }} transition={{
              duration: 1,
              repeat: Infinity
            }} data-id="element-659" />}
              </motion.div>)}
          </div>
          {/* Slide Counter */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1.2
        }} className="absolute top-12 right-12 text-white/50 text-2xl font-light" data-id="element-660">
            {String(currentSlide + 1).padStart(2, '0')} /{' '}
            {String(slides.length).padStart(2, '0')}
          </motion.div>
          {/* Scanning Line Effect */}
          <motion.div className="absolute left-0 right-0 h-1 bg-gradient-to-r from-transparent via-purple-500 to-transparent opacity-50" initial={{
          top: 0
        }} animate={{
          top: ['0%', '100%']
        }} transition={{
          duration: 8,
          repeat: Infinity,
          ease: 'linear'
        }} data-id="element-661" />
        </motion.div>
      </AnimatePresence>
      {/* Corner Accents */}
      <div className="absolute top-0 left-0 w-32 h-32 border-t-4 border-l-4 border-purple-500 opacity-50" data-id="element-662" />
      <div className="absolute top-0 right-0 w-32 h-32 border-t-4 border-r-4 border-pink-500 opacity-50" data-id="element-663" />
      <div className="absolute bottom-0 left-0 w-32 h-32 border-b-4 border-l-4 border-pink-500 opacity-50" data-id="element-664" />
      <div className="absolute bottom-0 right-0 w-32 h-32 border-b-4 border-r-4 border-purple-500 opacity-50" data-id="element-665" />
    </div>;
};
export default Slideshow;